import styled from "styled-components";
import { motion } from "framer-motion";

export const OblacicDecoration = styled(motion.img)`
  position: absolute;
  z-index: 2;
  pointer-events: none;
  max-width: ${(props) => props.$size || "8rem"};
  width: 100%;
  height: auto;
  top: ${(props) => props.$top || "20%"};
  left: ${(props) => props.$left || "auto"};
  right: ${(props) => props.$right || "auto"};
  transform: rotate(${(props) => props.$rotate || "0deg"});
  opacity: ${(props) => props.$opacity || "0.6"};
  filter: blur(${(props) => props.$blur || "0px"});

  @media (max-width: 768px) {
    max-width: ${(props) => props.$mobileSize || "5rem"};
  }
`;

export const AuthPageWrapper = styled.div`
  min-height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;
`;

export const AuthBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--plava) 0%, var(--bg-plava) 100%);
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill="%23ffffff" fill-opacity="0.05"><circle cx="7" cy="7" r="1"/><circle cx="27" cy="7" r="1"/><circle cx="47" cy="7" r="1"/><circle cx="7" cy="27" r="1"/><circle cx="27" cy="27" r="1"/><circle cx="47" cy="27" r="1"/><circle cx="7" cy="47" r="1"/><circle cx="27" cy="47" r="1"/><circle cx="47" cy="47" r="1"/></g></svg>');
    opacity: 0.1;
  }

  &::after {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 1px,
      transparent 1px
    );
    background-size: 50px 50px;
    animation: float 20s infinite linear;
  }

  @keyframes float {
    0% {
      transform: translate(0, 0) rotate(0deg);
    }
    100% {
      transform: translate(-50px, -50px) rotate(360deg);
    }
  }
`;

export const AuthWrapper = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 50rem;
`;

export const AuthContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 4rem;
  box-shadow:
    0 25px 60px rgba(0, 0, 0, 0.15),
    0 10px 30px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.3);

  @media (max-width: 768px) {
    padding: 3rem 2rem;
  }
`;

export const AuthTitle = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: var(--naslov-siva);
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const AuthSubtitle = styled.p`
  font-size: 1.6rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 3rem;
  text-align: center;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormGroup = styled.div`
  margin-bottom: 2rem;
  position: relative;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  padding: 1.5rem 2rem;
  padding-left: ${(props) =>
    props.$hasLeftIcon ? "calc(2rem + 17px)" : "2rem"};
  padding-right: ${(props) =>
    props.$hasRightIcon ? "calc(2rem + 17px)" : "2rem"};
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  font-size: 1.6rem;
  font-family: inherit;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--bg-plava);
    box-shadow: 0 0 0 3px rgba(46, 100, 143, 0.1);
  }

  &::placeholder {
    color: #999;
  }

  &.error {
    border-color: #dc3545;
    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
  }

  &.success {
    border-color: #28a745;
    box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
  }
`;

export const IconLeft = styled.div`
  position: absolute;
  left: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 1.4rem;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: var(--bg-plava);
  }
`;

export const RememberForgotRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Checkbox = styled.input`
  width: 1.8rem;
  height: 1.8rem;
  accent-color: var(--bg-plava);
  cursor: pointer;
  margin-top: 0.2rem;
  flex-shrink: 0;
`;

export const CheckboxLabel = styled.label`
  font-size: 1.4rem;
  color: #666;
  cursor: pointer;
  line-height: 1.5;
  user-select: none;
`;

export const AuthLink = styled.a`
  color: var(--bg-plava);
  text-decoration: none;
  font-weight: 600;
  font-size: 1.4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: color 0.3s ease;

  &:hover {
    color: var(--bg-plava);
    text-decoration: underline;
  }
`;

export const StyledAuthLink = styled.a`
  color: var(--bg-plava) !important;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.4rem;
  transition: color 0.3s ease;

  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 2rem;
`;

export const SignupText = styled.div`
  text-align: center;
`;

export const SignupTextContent = styled.span`
  color: #666;
  font-size: 1.4rem;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: left;
  margin: ${(props) =>
    props.$withMargin
      ? "0.5rem 0 0 0"
      : props.$withNegativeMargin
        ? "0.5rem 0 0 0"
        : "0"};
  margin-top: ${(props) => (props.$withNegativeMargin ? "-1rem" : "")};
  padding: 0;
`;

export const SuccessMessage = styled.div`
  background: #28a74520;
  color: #28a745;
  border: 1px solid #28a74540;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
  font-weight: 500;
  text-align: center;
`;

export const PasswordStrength = styled.div`
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: ${(props) => {
    switch (props.$strength) {
      case 1:
        return "#dc3545";
      case 2:
        return "#fd7e14";
      case 3:
        return "#ffc107";
      case 4:
        return "#28a745";
      default:
        return "#6c757d";
    }
  }};
`;

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BackToLoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const BackToLoginLink = styled.a`
  color: var(--bg-plava);
  text-decoration: none;
  font-weight: 600;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  transition: color 0.3s ease;

  &:hover {
    color: var(--bg-plava);
    text-decoration: underline;
  }
`;

export const BackArrowIcon = styled.span`
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
`;

export const LoadingWrapper = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const LoadingText = styled.p`
  font-size: 1.6rem;
  color: #666;
  margin: 0;
`;

export const InvalidTokenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-top: 2rem;
`;

export const InvalidTokenActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-top: 2rem;
`;

export const DemoTokenBox = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding: 2rem;
  background: rgba(40, 167, 69, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(40, 167, 69, 0.2);
`;

export const DemoTokenTitle = styled.p`
  font-size: 1.2rem;
  color: var(--bg-zelena);
  margin: 0 0 0.5rem 0;
  font-weight: 600;
`;

export const DemoTokenValue = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin: 0;
`;

export const CenteredErrorMessage = styled(ErrorMessage)`
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.4rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 0;
  width: 100%;
`;

export const StatusIcon = styled.div`
  font-size: 6rem;
  margin-bottom: 2rem;

  color: ${(props) => {
    switch (props.$status) {
      case "success":
        return "#22c55e";
      case "error":
        return "#ef4444";
      case "loading":
        return "var(--bg-zelena)";
      default:
        return "#666";
    }
  }};

  .spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const StatusTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--naslov-siva);
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const StatusMessage = styled.p`
  font-size: 1.6rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
  max-width: 450px;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export const VerificationForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  width: 100%;
`;

export const EmailDisplay = styled.p`
  color: #666;
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  text-align: center;
  margin-top: 1.5rem;

  strong {
    color: #333;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

export const VerificationButtonWrapper = styled(ButtonWrapper)`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  button {
    width: 100%;
  }
`;

export const AuthActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  width: 100%;
  align-items: center;
`;

export const HomeButton = styled.button`
  position: fixed;
  top: 2rem;
  left: 2rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  background: rgba(255, 255, 255, 0.95);

  border-radius: 2rem;
  color: var(--bg-plava);
  font-size: 1.4rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  z-index: 15;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: var(--bg-plava);
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
  }

  svg {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) {
    top: 1.5rem;
    left: 1.5rem;
    padding: 0.8rem 1.2rem;
    font-size: 1.2rem;

    svg {
      font-size: 1.4rem;
    }
  }
`;
